import { firestore } from "../../config/firebase";
import { doc, updateDoc } from "firebase/firestore";

const updateRegistrationPromo = async (id, obj) => {
  const registrationPromoRef = doc(firestore, "registrationPromos", id);
  await updateDoc(registrationPromoRef, obj);
};

export default updateRegistrationPromo;